let comments_loaded = false;

function lazy_load_unit(selector, script)
{
    var lazy_init_callback = function(){
        if( window.$(selector).length > 0 && window.$(selector).inViewport(50) ){
            init_unit(script, selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_unit(script , selector)
{
    if(comments_loaded == false){
        $(selector).after(script);
        comments_loaded = true;
    }
    
}

function comments_init(){
    
    
    if($('#comments-container').length > 0){
        
        if( $('.spot-im-widget-data').length > 0){
            
            var comments_obj = $('.spot-im-widget-data');
            
            var src = comments_obj.attr('data-src');
            var module = comments_obj.attr('data-spotim-module');
            var url = comments_obj.attr('data-post-url');
            var post_id = comments_obj.attr('data-post-id');
            var tags = comments_obj.attr('data-article-tags');
            
            var script = document.createElement('script');
            script.setAttribute('src', src);
            script.setAttribute( 'data-spotim-module', module );
            script.setAttribute('data-post-url', url);
            script.setAttribute('data-post-id', post_id);
            script.setAttribute('data-article-tags', tags);
            script.setAttribute('data-seo-enabled', true);
            
            //if the data-no-ads class exist we delete this ad to
            //We make a query selector to the data-no-ads class
            // var noAds = document.querySelector('[data-no-ads]');
            // //If the class exists, we return
            // if(noAds != null){
            //     $('.ad-location-1').remove();
            //     console.log('removing ad-location-1');
            // }else{
                lazy_load_unit('.spot-im-widget-data', script);
            // }
            
        }
        
    }
    
}

export default comments_init;